export default class Col {
    constructor(
        name,
        display,
        widthPct,
        key,
        isHeaderFilter,
        selectedHeaderFilters,
        headerFilterPlaceholder,
        onHeaderFilterChange,
        frontFilter,
        searchable = true,
        customMenuClassName = undefined,
        reverseSortOrder = false,
        displayReverseSortOrder = false,
    ) {
        this.name = name;
        this.display = display;
        this.widthPct = widthPct;
        this.isHeaderFilter = isHeaderFilter;
        this.selectedHeaderFilters = selectedHeaderFilters;
        this.headerFilterPlaceholder = headerFilterPlaceholder;
        this.onHeaderFilterChange = onHeaderFilterChange;
        this.frontFilter = frontFilter;
        this.key = key;
        this.searchable = searchable;
        this.customMenuClassName = customMenuClassName;
        this.reverseSortOrder = reverseSortOrder;
        this.displayReverseSortOrder = displayReverseSortOrder;
    }
}



// WEBPACK FOOTER //
// ./src/components/common/DataTableV2/Col.js